import { omitAnswers } from "./answers";
import { getStepResourceDeclarations, getWorkflowBlocksOfKind } from "./helpers";
import { getResourceDriver } from "./runtime/registry";
import type { AdapterDefinition } from "./types";

/**
 * Answers that must never be saved to the release: every `password` question, plus the values a
 * resource driver only needs while creating its resource.
 */
export const getSecretAnswerPaths = (definition: AdapterDefinition): string[] => [
  ...new Set([
    ...getWorkflowBlocksOfKind(definition, "questions").flatMap(({ block }) =>
      block.questions.filter((question) => question.type === "password").map((question) => question.key)),
    ...definition.workflow.flatMap((step) =>
      getStepResourceDeclarations(step).flatMap((declaration) => getResourceDriver(declaration).transientAnswerKeys ?? [])),
  ]),
];

export const omitSecretAnswers = <T extends Record<string, unknown>>(definition: AdapterDefinition, answers: T): T =>
  omitAnswers(answers, getSecretAnswerPaths(definition));
